import { portalapi } from 'src/helpers/axios'
// import { PERIODS, secondsuntil, adjustuntil, topup, period } from 'src/helpers/pricing.plugin'
import { ErrorService } from "../helpers/errorplugin"
const $log = ErrorService

const getDefaultState = () => {
  return {
    prices: [],
    flexiPrices: [],
    products: [], 
    activeProduct: undefined, // product object
    activeUntil: undefined, // date of expiry
    chosenProduct: undefined, // product object for creating new subscription
    chosenAdjustedProduct: undefined, // product object for adjusting subscription
    chosenPeriod: 'MONTH', // just stores the key as a string, FLEXI or MONTH
    special: null, // Special offer object
    minimumPrice: null, // Minimum price for payment calculations
    minimumUpgradePrice: 2.5, //Minimum price for payment calculations when upgrading
    worldpaySettings: {}, // worldpay config settings provided by server,
    uiSettings: {} // config for things such as URLs in frontend from backend properties file
  }
}

const state = getDefaultState()

const mutations= {
  setPrices: function(state, newprices) {
    state.prices = newprices;
  },
  setFlexiPrices: function(state, newflexiprices) {
    state.flexiPrices = newflexiprices;
  },
  setProducts: function(state, newproducts) {    
    state.products = newproducts;
  },
  setMinimumPrice: function(state, newminimum) {
    state.minimumPrice = newminimum;
  },
  setMinimumUpgradePrice: function(state, newupgradeprice) {
    state.minimumUpgradePrice = newupgradeprice;
  },
  
  setChosenProduct: function(state, newProductID){
    state.chosenProduct = (newProductID == null || state.products == undefined)
    ? undefined
    : state.products.find(s => {return s.productid === newProductID})
  },
  setChosenAdjustedProduct: function(state, newProductID) {
    state.chosenAdjustedProduct = (newProductID == null || state.products == undefined)
    ? undefined
    : state.products.find(s => {return s.productid === newProductID})
  },
  setChosenPeriod: function(state, newPeriodKey){
      state.chosenPeriod = newPeriodKey
  },
  setSpecial: function(state, newpayload) {
    $log.onError('new payload is '+JSON.stringify(newpayload))
    state.special = newpayload;
  },  
  setWorldpay: function(state, newpayload) {
    state.worldpaySettings = newpayload;
  },  
  setUiSettings: function(state, newpayload) {
    state.uiSettings = newpayload;
  },
  reset(state, type){
    Object.assign(state, getDefaultState())
  }
}



const getters = {
  getPrices: state => state.prices,
  getFlexiPrices: state => state.flexiPrices,
  getProducts: state => state.products,
  getChosenProduct: state => state.chosenProduct,
  getChosenAdjustedProduct: state => state.chosenAdjustedProduct,
  getChosenPeriod: state => state.chosenPeriod,
  getMinimumPrice: state => state.minimumPrice,
  getMinimumUpgradePrice: state => state.minimumUpgradePrice,
  getSpecial: state => state.special,
  getWorldpay: state => state.worldpaySettings,
  getUiSettings: state => state.uiSettings
  // getPriceAdjustments: state => {
  //   let adjusted = state.prices
  //   // const PERIOD = period()

  //   // $log.onDebug("unadjusted prices:" + JSON.stringify(adjusted))

  //   if ( adjusted != undefined) {
  //     // $log.onDebug("adjusting prices")
  //     // if we don't have an active product then there is nothing to adjust
  //     // if ( state.activeProduct != undefined ) {
  //       // let durationCurrent = secondsuntil(state.activeUntil)

  //       // // if there is an active product we need to show the impact of choosing
  //       // // one of the other products
  //       // for ( const p in adjusted){
  //       //   if ( adjusted[p].productid < state.activeProduct.productid) {
  //       //     // need an adjusted until date
  //       //     adjusted[p].until = adjustuntil(state.activeProduct.productid,adjusted[p].productid,durationCurrent)
  //       //     adjusted[p].topup = null
  //       //   } else if ( adjusted[p].productid > state.activeProduct.productid) {
  //       //     // need a topup price
  //       //     adjusted[p].topup = topup( adjusted[p].price, adjusted['svc' + state.activeProduct.productid].price, durationCurrent, PERIOD.seconds)
  //       //     adjusted[p].until = null
  //       //   } else {
  //       //     adjusted[p].topup = null
  //       //     adjusted[p].until = null            
  //       //   }          
  //       // }    
        
  //     // } else {
  //     //   for ( const p in adjusted){
  //     //     adjusted[p].topup = null
  //     //     adjusted[p].until = null
  //     //   }
  //     // }

  //     // $log.onDebug("special:" + JSON.stringify(state.special))
  //     // apply any discount
  //     if ( state.special !== null && state.special.type === 'BASE') {// && state.chosenPeriod === 'MONTH') {
  //       // adjusted.svc3.discounted = adjusted.svc3.price - adjusted.svc1.price 
  //       // adjusted.svc2.discounted = adjusted.svc2.price - adjusted.svc1.price
  //       // adjusted.svc1.discounted = 0 
  //       prices.forEach((price) => {

  //       })
  //     } else {
  //       for ( const p in adjusted){
  //         adjusted[p].discounted = adjusted[p].price
  //       }        
  //     }
  //   }
    
  //   return adjusted
  // }
}

const actions = {
  
  setChosenProduct: ({dispatch, commit }, id ) => {
    commit("setChosenProduct", id)    
  },
  setChosenAdjustedProduct: ({dispatch, commit }, id) => {
    commit("setChosenAdjustedProduct", id)
  },
  setChosenPeriod: ({dispatch, commit }, id ) => {
    commit("setChosenPeriod", id)    
  },
  setSpecial: ({dispatch, commit }, payload ) => {
    $log.onError('payload in setSpecial is '+JSON.stringify(payload))
    commit("setSpecial", payload)
  },
  initialiseProducts: ({dispatch, commit }) => {
    $log.onDebug("fetching products")
    portalapi.get('/open/product/base')
      .then((response) => {
        // do something with both responses
        let products = response.data.map((row) => 
          { 
            return {
              ...row,
              class: 'svc' + row.productid 
            }
          }).sort((a, b) => {return b.productid-a.productid})
        $log.onDebug("Products:" + JSON.stringify(products))
        commit("setProducts", products)
        commit("setChosenProduct", products[0].productid)
        commit("setChosenPeriod", 'MONTH')
      }, error => {
        $log.onError("Failed to load products:" + JSON.stringify(error))
      })

  },
  initialisePrices: ({getters, dispatch, commit }, adjusted) => {
    $log.onDebug("fetching prices")
    $log.onDebug('special is ' + JSON.stringify(getters.getSpecial))
    let specialid = getters.getSpecial != null ? getters.getSpecial.id : null
    portalapi.get('/open/siteprices', { params: {specialid: specialid, adjusted: adjusted} })
      .then((response) => {
        let prices = response.data
        
        // turn the array into something useful
        // prices[PERIODS.MONTH.key] = {}

        // let rd = response.data

        // rd.forEach(e => {
        //   prices[PERIODS.MONTH.key]['svc' + e.productid] = { price: e.monthlyPrice, discounted: e.monthlyPrice, productid: e.productid}
        // });
  
        $log.onDebug("Prices:" + JSON.stringify(prices))
        commit("setPrices", prices)
      }, error => {
        $log.onError("Failed to fetch prices:" + JSON.stringify(error))
      })

    portalapi.get('/open/flexiprices')
      .then((response) => {
        let flexPrices = []
        let minimum = null

        flexPrices = response.data;
        flexPrices.forEach(e => {
          if (minimum === null || minimum > e.price) minimum = e.price;
        })

        commit("setMinimumPrice", minimum)
        commit("setFlexiPrices", flexPrices)
      }, error => {
        $log.onError('flexi error: ' + JSON.stringify(error))
      })
    
  },
  initialiseWorldpay: ({dispatch, commit }) => {
    $log.onDebug("fetching worldpaySettings")
    portalapi.get('/open/worldpay/settings')
      .then((response) => {
        // do something with both responses
        let wp = response.data
        $log.onDebug("Worldpay:" + JSON.stringify(wp))
        commit("setWorldpay", wp)
      }, error => {
        $log.onError("Failed to load worldpay settings:" + JSON.stringify(error))
      })

  },
  initialiseUiSettings: ({dispatch, commit}) => {
    $log.onDebug("fetching uiSettings")
    portalapi.get('/open/ui/settings')
      .then((response) => {
        // do something with both responses
        let ui = response.data
        $log.onDebug("UI:" + JSON.stringify(ui))
        commit("setUiSettings", ui)
      }, error => {
        $log.onError("Failed to load ui settings:" + JSON.stringify(error))
      })

  },
  reset({commit}, type){
    commit('reset', type)    
  }
}
      
export const pricing = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
  };
    
